import "./Journal.module.css";
import Header from "@/reusable_sections/Header";
import JournalArchives from "./sections/JournalArchives";
import BrowseByRoom from "./sections/BrowseByRoom";
import SiteFooter from "@/reusable_sections/Footer";
export default function JournalPage() {
  return <div>
      <Header />
      <JournalArchives />
      <BrowseByRoom />
      <SiteFooter />
    </div>;
}